import React from "react";
import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800">
      <div className="max-w-md text-center bg-white p-8 rounded-2xl shadow-lg">
        <h1 className="text-4xl font-bold text-red-600 mb-4">Oops! Something went wrong.</h1>

        {/* Handle error safely */}
        <p className="text-lg text-gray-600">
          {error?.status
            ? `Error ${error.status}: ${error.statusText}`
            : "An unexpected error occurred."}
        </p>

        {/* Button to go home */}
        <a
          href="/"
          className="mt-6 inline-block bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition-all"
        >
          Go Back Home
        </a>
      </div>
    </div>
  );
};

export default ErrorPage;
